(() => {
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const showNeed = (root, index) => {
    const slides = [...root.querySelectorAll('[data-jc-need-slide]')];
    const tabs = [...root.querySelectorAll('[data-jc-need-tab]')];
    const points = [...root.querySelectorAll('[data-jc-need-point]')];
    slides.forEach((slide, position) => {
      const active = position === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    tabs.forEach((tab, position) => {
      const active = position === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-current', active ? 'true' : 'false');
    });
    points.forEach((point, position) => point.classList.toggle('is-active', position === index));
  };

  const initNeedTabs = () => {
    document.querySelectorAll('[data-jc-need-tabs]').forEach((root) => {
      if (root.dataset.jcNeedReady === 'true') return;
      root.dataset.jcNeedReady = 'true';
      const tabs = [...root.querySelectorAll('[data-jc-need-tab]')];
      let current = 0;
      showNeed(root, current);
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          current = index;
          showNeed(root, current);
        });
      });
      let startX = 0;
      root.addEventListener('pointerdown', (event) => { if (mobileQuery.matches) startX = event.clientX; }, { passive: true });
      root.addEventListener('pointerup', (event) => {
        if (!mobileQuery.matches || !startX) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 42) {
          current = (current + (delta < 0 ? 1 : tabs.length - 1)) % tabs.length;
          showNeed(root, current);
        }
        startX = 0;
      }, { passive: true });
    });
  };

  const initIngredientTabs = () => {
    document.querySelectorAll('[data-jc-ingredient-tabs]').forEach((root) => {
      if (root.dataset.jcIngredientReady === 'true') return;
      root.dataset.jcIngredientReady = 'true';
      const section = root.closest('.jc-ingredient-story');
      const quality = section?.querySelector('[data-jc-ingredient-quality]');
      const coverflow = section?.querySelector('[data-jc-coverflow-root]');
      [...root.querySelectorAll('[data-jc-ingredient-tab]')].forEach((tab) => {
        tab.addEventListener('click', () => {
          const isQuality = tab.dataset.jcIngredientTab === 'quality';
          root.querySelectorAll('[data-jc-ingredient-tab]').forEach((button) => {
            const active = button === tab;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          if (quality) quality.hidden = !isQuality;
          if (coverflow) coverflow.classList.toggle('jc-mobile-stage-hidden', isQuality);
        });
      });
    });
  };

  const initialise = () => {
    if (!mobileQuery.matches) return;
    document.documentElement.classList.add('jc-p0p1-ready');
    initNeedTabs();
    initIngredientTabs();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  window.addEventListener('load', () => window.setTimeout(initialise, 220), { once: true });
  [650, 1400, 2600, 4200].forEach((delay) => window.setTimeout(initialise, delay));
  document.addEventListener('shopify:section:load', initialise);
})();
